export class BatchApplicationOverrides {
    'resourceIds';
    'applications';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "applications",
            "baseName": "applications",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchApplicationOverrides.attributeTypeMap;
    }
    constructor() {
    }
}
